<template>
  <div id="message">
    <div>
      <div class="content">
        <h4>{{list.title}}</h4>
        <p>{{list.time}}</p>
        <!-- <p v-html="replace(list.content)"></p> -->
        <p v-html="htmlDecodeByRegExp(list.content)"></p>
      </div>
      <div class="footer">
        <p>爱易货网</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlatformMessage',
  props: {
    list: {
      title: '',
      time: '',
      content: ''
    }
  },
  methods: {
    htmlDecodeByRegExp (str) {
      var s = ''
      // console.log(str.length)
      if (str === '') return ''
      s = str.replace(/&amp;/g, '&')
      s = s.replace(/&lt;/g, '<')
      s = s.replace(/&gt;/g, '>')
      s = s.replace(/&nbsp;/g, ' ')
      s = s.replace(/&quot;/g, '\'')
      return s
    }
  }
}
</script>

<style scoped>
.content{ padding: 10px 15px;}
.content h4{ text-align: center; padding: 15px 0;}
.content p{ font-size: 14px; line-height: 25px;}
.content img{ width: 100%;}
.content .last{ margin-top: 20px;}
.footer{ float: right; margin-right: 20px; font-size: 14px;}
</style>



// WEBPACK FOOTER //
// src/pages/platform/components/Message.vue